export enum Path {
  HOME = "/",
  EXPLORE = "/book",
  BOOK = "/book/:nameKey",
  BOOK_SERVICE = "/book/:nameKey/:shopKey/service/",
  BOOK_STAFF = "/book/:nameKey/:shopKey/service/:serviceId/serviceProvider",
  CART_INIT = "/book/:nameKey/:shopKey/service/:serviceId/serviceProvider/:serviceProviderId",
  BOOK_TIME = "/book/:nameKey/:shopKey/schedule",
  MANAGE_BOOKING = "/book/:nameKey/manage-booking/:token",
  CANCELED_BOOKING = "/book/:nameKey/canceled-booking",
  ORDER = "/order/:nameKey/:shopKey",
  ORDER_COMPLETE = "/order/:nameKey/:shopKey/complete",
  SIGNUP = "/signup",
  SIGNIN = "/signin",
  SETTINGS = "/settings",
}
